import React from "react";

const toneClasses = {
  neutral: "bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-300",
  success:
    "bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300",
  warning:
    "bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300",
  danger: "bg-rose-100 dark:bg-rose-900/30 text-rose-700 dark:text-rose-300",
  info: "bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300",
};

const Badge = ({ children, tone = "neutral", className = "" }) => {
  return (
    <span
      className={[
        "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide",
        toneClasses[tone] || toneClasses.neutral,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </span>
  );
};

export default Badge;
